import {useCookies} from 'react-cookie';
import {IS_AUTHENTICATED_COOKIE} from '../external-components/authentication/AuthContext';

export const AUTH_COOKIE = 'AUTH';
export const JWT_COOKIE = 'JWT';

function useClearTrace() {
    const [, , removeCookie] = useCookies();

    return () => {
        console.log('clearing Trace');

        localStorage.clear();
        sessionStorage.clear();
        removeCookie(IS_AUTHENTICATED_COOKIE);
        removeCookie(AUTH_COOKIE);
        removeCookie(JWT_COOKIE);
    };
}

export default useClearTrace;
